import moment from 'moment'
import 'moment/locale/ru'
import storage from '../common/utils/storage'

const localStorageLng = storage.getValue('lng') ? storage.getValue('lng').split('-')[0] : 'en'

const times = {
    sec: {
        en: 'sec',
        ru: 'сек',
    },
    min: {
        en: 'min',
        ru: 'мин',
    },
    h: {
        en: 'h',
        ru: 'ч',
    },
    day: {
        en: 'day',
        ru: 'дней',
    },
    weeks: {
        en: 'weeks',
        ru: 'недель',
    },
}
const numbers = {
    k: {
        en: 'k',
        ru: 'тыс',
    },
    m: {
        en: 'm',
        ru: 'млн',
    },
    b: {
        en: 'b',
        ru: 'млрд',
    },
}

// Если не приходит параметр указанный напрямую lng - берем из localStorage
const getFormatValue = (int, digits, high_digits_value, units, high_units) => {
    const digits_rounded = parseInt((digits * 10).toFixed(0))
    const high_round = digits_rounded === 10

    if (digits_rounded && !high_round) {
        return `${int},${digits_rounded} ${units}`
    } else {
        int += high_round ? 1 : 0
        return int !== high_digits_value ? `${int} ${units}` : `1 ${high_units}`
    }
}

export const formattedTime = (seconds = 0, lng = localStorageLng) => {
    const moment_duration = moment.duration(seconds, 'seconds')

    const _days = moment_duration.days()
    const _hours = moment_duration.hours()
    const _minutes = moment_duration.minutes()
    const _seconds = moment_duration.seconds()

    if (_days) {
        return getFormatValue(
            _days,
            (_hours * 3600 + _minutes * 60 + _seconds) / 86400,
            7,
            times.day[lng],
            times.weeks[lng],
        )
    }
    if (_hours) {
        return getFormatValue(_hours, (_minutes * 60 + _seconds) / 3600, 24, times.h[lng], times.day[lng])
    }
    if (_minutes) {
        return getFormatValue(_minutes, _seconds / 60, 60, times.min[lng], times.h[lng])
    }

    return seconds ? `${seconds} ${times.sec[lng]}` : 0
}

export const formattedNumber = (value = 0, lng = localStorageLng) => {
    const _million = Math.trunc(value / 1000000)
    const _thousand = Math.trunc(value / 1000)

    if (_million) {
        return getFormatValue(_million, (value - _million * 1000000) / 1000000, 1000000, numbers.m[lng], numbers.b[lng])
    }
    if (_thousand) {
        return getFormatValue(_thousand, (value - _thousand * 1000) / 1000, 1000, numbers.k[lng], numbers.m[lng])
    }

    return value
}

export const capitalize_first_letter = str => {
    return str.charAt(0).toUpperCase() + str.slice(1)
}
